import { UpdateBehaviorTreatmentProperties } from '../../../redux/API/ClientAPIHelpers/soapNoteProperties';

export enum ACTIONS {
	setState = 'setState',
	setBarrierToTreatmentResponses = 'setBarrierToTreatmentResponses',
	setBehaviorTreatmentTechniquesResponses = 'setBehaviorTreatmentTechniquesResponses',
	setMaladaptiveBehaviors = 'setMaladaptiveBehaviors',
	setPromptLevelsResponses = 'setPromptLevelsResponses',
	setReinforcementResponses = 'setReinforcementResponses',
	setReinforcementOther = 'setReinforcementOther',
	setMaladaptiveTechniquesResponses = 'setMaladaptiveTechniquesResponses',
	setDate = 'setDate',
	setEndTime = 'setEndTime',
	setStartTime = 'setStartTime',
	setLocationId = 'setLocationId',
	setSessionDescription = 'setSessionDescription',
	setSessionId = 'setSessionId',
	setSignature = 'setSignature',
	setSupervisorId = 'setSupervisorId',
	setSupervisor = 'setSupervisor',
	setBarrierToTreatmentOther = 'setBarrierToTreatmentOther',
	setHowBarrierAffect = 'setHowBarrierAffect',
	setSkillDomainAddressed = 'setSkillDomainAddressed',
	setWorkedGoals = 'setWorkedGoals',
	setLevelOfMaladaptiveBehavior = 'setLevelOfMaladaptiveBehavior',
	setFrequencyAndDurationOfMaladaptiveBehaviors = 'setFrequencyAndDurationOfMaladaptiveBehaviors',
	setClientResponseToTreatment = 'setClientResponseToTreatment',
	setClientMoodResponses = 'setClientMoodResponses',
	setFuturePlanResponses = 'setFuturePlanResponses',
	setParticipants = 'setParticipants',
	setIsAiGenerated = 'setIsAiGenerated',
	setIsSessionSupervised = 'setIsSessionSupervised',
	setClientMoodOther = 'setClientMoodOther',
	setFuturePlanOther = 'setFuturePlanOther',
	setBehaviorTreatmentParticipantOther = 'setBehaviorTreatmentParticipantOther',
}

export interface ActionProperties {
	payload: any;
	type: keyof typeof ACTIONS;
}

export const initialBehaviorTreatmentState: UpdateBehaviorTreatmentProperties = {
	isAiGenerated: false,
	isSessionSupervised: false,
	barrierToTreatmentResponses: [],
	behaviorTreatmentTechniquesResponses: [],
	skillDomainAddressedResponses: [],
	clientMoodResponses: [],
	promptLevelsResponses: [],
	reinforcementResponses: [],
	maladaptiveBehaviorTechniquesResponses: [],
	behaviorTreatmentFuturePlanResponses: [],
	barrierToTreatmentOther: '',
	howBarrierAffect: '',
	date: '',
	endTime: '',
	locationId: null,
	maladaptiveBehaviors: '',
	notes: '',
	sessionDescription: '',
	workedGoals: '',
	sessionId: '',
	signature: '',
	startTime: '',
	supervisorId: '',
	supervisor: {
		id: '',
		email: '',
		firstName: '',
		fullName: '',
		lastName: '',
		role: {
			id: '',
			name: '',
			section: {
				id: 0,
				name: '',
			},
		},
	},
	frequencyAndDurationOfMaladaptiveBehaviors: '',
	submit: false,
	responseToIntervention: null,
	levelOfMaladaptiveBehavior: null,
	forcedOperation: false,
	clientResponseToTreatment: null,
	participantResponses: [],
	clientId: '',
	reportId: '',
	sessionSummary: '',
	clientTelehealthLocationId: '',
	userTelehealthLocationId: '',
	behaviorTreatmentFuturePlanOther: '',
	clientMoodOther: '',
	reinforcementOther: '',
	behaviorTreatmentParticipantOther: '',
};

export const behaviorTreatmentReducer = (
	state: UpdateBehaviorTreatmentProperties,
	action: ActionProperties,
): UpdateBehaviorTreatmentProperties => {
	const { type, payload } = action;

	switch (type) {
		case ACTIONS.setState:
			return {
				...initialBehaviorTreatmentState,
				...payload,
			};
		case ACTIONS.setIsAiGenerated:
			return {
				...state,
				isAiGenerated: payload,
			};
		case ACTIONS.setIsSessionSupervised:
			return {
				...state,
				isSessionSupervised: payload,
			};
		case ACTIONS.setLocationId:
			return {
				...state,
				locationId: payload,
			};
		case ACTIONS.setSupervisorId:
			return {
				...state,
				supervisorId: payload,
			};
		case ACTIONS.setSupervisor:
			return {
				...state,
				supervisor: payload,
			};
		case ACTIONS.setHowBarrierAffect:
			return {
				...state,
				howBarrierAffect: payload,
			};
		case ACTIONS.setBarrierToTreatmentResponses:
			return {
				...state,
				barrierToTreatmentResponses: payload,
			};
		case ACTIONS.setBehaviorTreatmentTechniquesResponses:
			return {
				...state,
				behaviorTreatmentTechniquesResponses: payload,
			};
		case ACTIONS.setMaladaptiveTechniquesResponses:
			return {
				...state,
				maladaptiveBehaviorTechniquesResponses: payload,
			};
		case ACTIONS.setReinforcementResponses:
			return {
				...state,
				reinforcementResponses: payload,
			};
		case ACTIONS.setPromptLevelsResponses:
			return {
				...state,
				promptLevelsResponses: payload,
			};
		case ACTIONS.setMaladaptiveBehaviors:
			return {
				...state,
				maladaptiveBehaviors: payload,
			};
		case ACTIONS.setSessionDescription:
			return {
				...state,
				sessionDescription: payload,
			};
		case ACTIONS.setWorkedGoals:
			return {
				...state,
				workedGoals: payload,
			};
		case ACTIONS.setBarrierToTreatmentOther:
			return {
				...state,
				barrierToTreatmentOther: payload,
			};
		case ACTIONS.setSkillDomainAddressed:
			return {
				...state,
				skillDomainAddressedResponses: payload,
			};
		case ACTIONS.setLevelOfMaladaptiveBehavior:
			return {
				...state,
				levelOfMaladaptiveBehavior: payload,
			};
		case ACTIONS.setFrequencyAndDurationOfMaladaptiveBehaviors:
			return {
				...state,
				frequencyAndDurationOfMaladaptiveBehaviors: payload,
			};
		case ACTIONS.setClientResponseToTreatment:
			return {
				...state,
				clientResponseToTreatment: payload,
			};
		case ACTIONS.setSignature:
			return {
				...state,
				signature: payload,
			};
		case ACTIONS.setClientMoodResponses:
			return {
				...state,
				clientMoodResponses: payload,
			};
		case ACTIONS.setFuturePlanResponses:
			return {
				...state,
				behaviorTreatmentFuturePlanResponses: payload,
			};
		case ACTIONS.setParticipants:
			return {
				...state,
				participantResponses: payload,
			};
		case ACTIONS.setClientMoodOther:
			return {
				...state,
				clientMoodOther: payload,
			};
		case ACTIONS.setFuturePlanOther:
			return {
				...state,
				behaviorTreatmentFuturePlanOther: payload,
			};
		case ACTIONS.setReinforcementOther:
			return {
				...state,
				reinforcementOther: payload,
			};
		case ACTIONS.setBehaviorTreatmentParticipantOther:
			return {
				...state,
				behaviorTreatmentParticipantOther: payload,
			};
		default:
			return state;
	}
};

export enum ERRORS {
	BarrierToTreatmentResponses = 'BarrierToTreatmentResponses',
	BehaviorTreatmentFuturePlanResponses = 'BehaviorTreatmentFuturePlanResponses',
	BarrierToTreatmentOther = 'BarrierToTreatmentOther',
	BehaviorTreatmentTechniquesResponses = 'BehaviorTreatmentTechniquesResponses',
	ClientMoodResponses = 'ClientMoodResponses',
	ClientResponseToTreatment = 'ClientResponseToTreatment',
	FrequencyAndDurationOfMaladaptiveBehaviors = 'FrequencyAndDurationOfMaladaptiveBehaviors',
	HowBarrierAffect = 'HowBarrierAffect',
	LevelOfMaladaptiveBehavior = 'LevelOfMaladaptiveBehavior',
	LocationId = 'LocationId',
	MaladaptiveBehaviorTechniquesResponses = 'MaladaptiveBehaviorTechniquesResponses',
	Notes = 'Notes',
	Reinforcement = 'Reinforcement',
	SessionDescription = 'SessionDescription',
	Signature = 'Signature',
	SkillDomainAddressedResponses = 'SkillDomainAddressedResponses',
	WorkedGoals = 'WorkedGoals',
	ParticipantResponses = 'ParticipantResponses',
	ClientMoodOther = 'ClientMoodOther',
	FuturePlanOther = 'FuturePlanOther',
	ReinforcementOther = 'ReinforcementOther',
	BehaviorTreatmentParticipantOther = 'BehaviorTreatmentParticipantOther',
}

interface BehaviorTreatmentErrorProperties {
	BarrierToTreatmentOther: boolean;
	BarrierToTreatmentResponses: boolean;
	BehaviorTreatmentFuturePlanResponses: boolean;
	BehaviorTreatmentParticipantOther: boolean;
	BehaviorTreatmentTechniquesResponses: boolean;
	ClientMoodOther: boolean;
	ClientMoodResponses: boolean;
	ClientResponseToTreatment: boolean;
	FrequencyAndDurationOfMaladaptiveBehaviors: boolean;
	FuturePlanOther: boolean;
	HowBarrierAffect: boolean;
	LevelOfMaladaptiveBehavior: boolean;
	LocationId: boolean;
	MaladaptiveBehaviorTechniquesResponses: boolean;
	Notes: boolean;
	ParticipantResponses: boolean;
	Reinforcement: boolean;
	ReinforcementOther: boolean;
	SessionDescription: boolean;
	Signature: boolean;
	SkillDomainAddressedResponses: boolean;
	WorkedGoals: boolean;
}

export interface ErrorActionProperties {
	payload: any;
	type: keyof typeof ERRORS;
}

export const initialBehaviorTreatmentErrorState: BehaviorTreatmentErrorProperties = {
	LocationId: false,
	BarrierToTreatmentOther: false,
	BarrierToTreatmentResponses: false,
	BehaviorTreatmentFuturePlanResponses: false,
	BehaviorTreatmentTechniquesResponses: false,
	ClientMoodResponses: false,
	ClientMoodOther: false,
	ClientResponseToTreatment: false,
	FrequencyAndDurationOfMaladaptiveBehaviors: false,
	HowBarrierAffect: false,
	LevelOfMaladaptiveBehavior: false,
	MaladaptiveBehaviorTechniquesResponses: false,
	Notes: false,
	Reinforcement: false,
	SessionDescription: false,
	Signature: false,
	SkillDomainAddressedResponses: false,
	WorkedGoals: false,
	ParticipantResponses: false,
	FuturePlanOther: false,
	ReinforcementOther: false,
	BehaviorTreatmentParticipantOther: false,
};

export const behaviorTreatmentErrorReducer = (
	state: BehaviorTreatmentErrorProperties,
	action: ErrorActionProperties,
) => {
	const { payload, type } = action;

	switch (type) {
		case ERRORS[type]: {
			return {
				...state,
				[type]: payload,
			};
		}
		default:
			return state;
	}
};
